const sessionStorageKeys = [];
export const clearGlobalStore = () => {
  sessionStorage.clear();
};

export const setGlobalValue = (key, value) => {
  if (!sessionStorageKeys.includes(key)) {
    sessionStorageKeys.push(key);
  }

  sessionStorage.setItem(key, JSON.stringify(value));
};

export const getGlobalValue = (key) => {
  const value = sessionStorage.getItem(key);

  if (value) {
    return JSON.parse(value);
  }
};
